import React from 'react';
import PropTypes from 'prop-types';
import { ButtonPill, Direction, Column, TextSmall, Margin } from '@scotia/canvas-react';
import cx from 'classnames';
import style from './error.scss';
import { Constants } from '../../constants/Constants';

const ErrorComponent = ({ actionClick, error, border, reduced, text, showButton }) => (
  <div>
    <Direction
      style={border ? { border: 'solid 1px #e2e8ee' } : null}
      className={cx(style['error-container'], { [style.padding]: !reduced })}
      side={'row'}
    >
      <Column xs={12}>
        <TextSmall>{text || Constants.errorSummary}</TextSmall>
      </Column>
      {showButton && (
        <Column xs={12}>
          <Margin xs={24} side={'top'}>
            <ButtonPill variant="help" onClick={actionClick} disabled={!error}>
              Volver a cargar
            </ButtonPill>
          </Margin>
        </Column>
      )}
    </Direction>
  </div>
);

ErrorComponent.propTypes = {
  actionClick: PropTypes.func.isRequired,
  error: PropTypes.bool,
  border: PropTypes.bool,
  reduced: PropTypes.bool,
  text: PropTypes.string,
  showButton: PropTypes.bool,
};

ErrorComponent.defaultProps = {
  error: true,
  border: true,
  reduced: false,
  text: undefined,
  showButton: true,
};

export default ErrorComponent;
